// extracted by mini-css-extract-plugin
module.exports = {"fuselage":"flipflop_fuselage__A0qOr","image":"flipflop_image__Lo3iM","body":"flipflop_body__Ftlir","flipped":"flipflop_flipped__9x6WZ"};